import React from "react";
import Notifications from "../../../components/user/notification/Notification";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import Footer from "../../../components/user/footer/Footer";
import { Container, Row } from "react-bootstrap";
import SupportDisputes from "../supportDisputes/SupportDisputes";
const SupportTickets = () => {
  return (
    <Container fluid>
      <Navbar />
      <SimpleBanner
        // path={"Home > All Deals"}
        title="Support & Disputes"
        subtitle="Because the Best Things Deserve to Wait."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "orders", href: "/customer-orders" },
          { label: "support ticket", href: "/support-tickets" },
          //   { label: "wishlist Details", current: true },
        ]}
      />
      <Row>
        {/* <AllDealsCard screenName={"wishlist"}/>
        <AllDealsCard screenName={"wishlist"}/>
        <AllDealsCard screenName={"wishlist"}/>
        <AllDealsCard screenName={"wishlist"}/> */}
        <SupportDisputes />
      </Row>
      <Footer />
    </Container>
  );
};
export default SupportTickets;
